'use strict';
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_app$002eutils$002e$002dNewtype$002dMass from "./app.utils.-Newtype-Mass.js";
import * as $j_app$002eutils$002e$002dNewtype$002dMass$0024$0024anon$00241 from "./app.utils.-Newtype-Mass$$anon$1.js";
import * as $j_app$002eutils$002e$002dNewtype$002dMass$0024$0024anon$00243 from "./app.utils.-Newtype-Mass$$anon$3.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$() {
  this.aND = null;
  this.aNE = false;
  this.aNx = null;
  this.aNy = false;
  this.aNv = null;
  this.aNw = false;
  this.aNB = null;
  this.aNC = false;
  this.aNF = null;
  this.aNG = false;
  this.aNz = null;
  this.aNA = false;
}
export { $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$ as $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$ };
$p = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$;
/** @constructor */
function $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$() {
}
export { $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$ as $h_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$ };
$h_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$.prototype = $p;
$p.aA = (function() {
  if ((!this.aNE)) {
    this.aND = new $j_app$002eutils$002e$002dNewtype$002dMass$0024$0024anon$00241.$c_Lapp_utils_NewtypeMass$$anon$1(this);
    this.aNE = true;
  }
  return this.aND;
});
$p.iq = (function() {
  if ((!this.aNy)) {
    this.aNx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_CanEqual$derived$();
    this.aNy = true;
  }
  return this.aNx;
});
$p.il = (function() {
  if ((!this.aNw)) {
    this.aNv = $j_app$002eutils$002e$002dNewtype$002dMass.$f_Lapp_utils_NewtypeMass__empty__Lalleycats_Empty(this);
    this.aNw = true;
  }
  return this.aNv;
});
$p.eY = (function() {
  if ((!this.aNC)) {
    this.aNB = $j_app$002eutils$002e$002dNewtype$002dMass.$f_Lapp_utils_NewtypeMass__given_QuantityEquals_Type__Lapp_data_FormQuantity$QuantityEquals(this);
    this.aNC = true;
  }
  return this.aNB;
});
$p.Jq = (function() {
  if ((!this.aNG)) {
    this.aNF = new $j_app$002eutils$002e$002dNewtype$002dMass$0024$0024anon$00243.$c_Lapp_utils_NewtypeMass$$anon$3(this);
    this.aNG = true;
  }
  return this.aNF;
});
$p.w0 = (function() {
  if ((!this.aNA)) {
    this.aNz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Net Weight";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aNA = true;
  }
  return this.aNz;
});
var $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$, "app.data.data_point_types$package$NetWeight$", ({
  G9: 1,
  B: 1,
  C: 1,
  ky: 1
}));
export { $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$ as $d_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$ };
var $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$;
function $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$() {
  if ((!$n_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$)) {
    $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$ = new $c_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$();
  }
  return $n_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$;
}
export { $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$ as $m_Lapp_data_data\uff3fpoint\uff3ftypes$package$NetWeight$ };
//# sourceMappingURL=app.data.data_point_types$package$-Net-Weight$.js.map
